import {
    GovFormControl,
    GovFormGroup,
    GovFormLabel,
    GovFormMessage,
    GovFormMultiSelect
} from "@gov-design-system-ce/react";

export interface MultiSelectOption {
    value: string;
    label?: string;
    disabled?: boolean;
    selected?: boolean;
}

export interface MultiSelectProps {
    value?: string;
    readOnly?: boolean;
    prefix?: string;
    suffix?: string;
    message?: string;
    label?: string;
    onChange?: (value: any[]) => void;
    options: MultiSelectOption[];
}

export default function MultiSelect(props: MultiSelectProps) {
    const {readOnly, message, label, onChange, options} = props;

    return (
        <GovFormControl>
            <div>
                {label && <GovFormLabel slot="top" size="l">
                    {label}
                </GovFormLabel>}
                <GovFormGroup>
                    <GovFormMultiSelect size="m" variant="secondary" input-type="text"
                                        disabled={readOnly}
                                        onGov-change={(e) => onChange && onChange(e.detail.value.map(option => option.value))}
                                        defaultValue={options.map(option => option.value)}
                    >
                        {options.map((option, key) => (
                            <option key={"option" + key} value={option.value} disabled={option.disabled}
                                    selected={option.selected}>
                                {option.label ? option.label : option.value}
                            </option>
                        ))}
                    </GovFormMultiSelect>
                </GovFormGroup>

                {message && <GovFormMessage slot={"bottom"} variant={"secondary"}>
                    {message}
                </GovFormMessage>}
            </div>

        </GovFormControl>
    );

}